import { groupArrayByKey } from '@campus/utils';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GroupPersonInterface } from '../../+models';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './group-person.reducer';

export const selectGroupPersonState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectGroupPersonState, (state: State) => state.error);

export const getLoaded = createSelector(selectGroupPersonState, (state: State) => state.loaded);

export const getAll = createSelector(selectGroupPersonState, selectAll);

export const getCount = createSelector(selectGroupPersonState, selectTotal);

export const getIds = createSelector(selectGroupPersonState, selectIds);

export const getAllEntities = createSelector(selectGroupPersonState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * groupPerson$: GroupPersonInterface[] = this.store.pipe(
    select(GroupPersonQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectGroupPersonState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * groupPerson$: GroupPersonInterface = this.store.pipe(
    select(GroupPersonQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectGroupPersonState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const getByGroupId = createSelector(
  getAll,
  (groupPersons: GroupPersonInterface[]): Dictionary<GroupPersonInterface[]> => groupArrayByKey(groupPersons, 'groupId')
);

export const getByPersonId = createSelector(
  getAll,
  (groupPersons: GroupPersonInterface[]): Dictionary<GroupPersonInterface[]> =>
    groupArrayByKey(groupPersons, 'personId')
);
